const login = {
   // seems to be deprecated >> see public/conf/login-messages.js
   useKeycloak: false,
   maintenance: {
    show: false,
    html: '<p><u>Bitte beachten Sie:</u></p><p>Aufgrund von Wartungsarbeiten steht der Online-Campus am Samstag, den 20.07.2019, zwischen 10:00 und 16:00 Uhr nicht zur Verfügung.</p><p>Wir bitten Sie, entstehende Unannehmlichkeiten zu entschuldigen. </p>'
   },
   footer: [{
     label: 'Wilhelm Büchner University',
     uri: 'http://www.wb-university.com/',
     target: '_blank'
   }, {
     label: 'Data protection statement',
     uri: 'http://www.wb-university.com/data-protection-notice/',
     target: '_blank'
   }, {
     label: 'Imprint',
     uri: 'http://www.wb-university.com/imprint/',
     target: '_blank'
   }]
}
export default { login }
